export enum NumericAccessLevel {
    level1 = 1,
    level2 = 2,
    level3 = 3,
}
